import React from "react"

import { useQuery } from "@tanstack/react-query"
import { DateTime } from "luxon"

import { TableCell, TableRow } from "@/components/ui/table"

import { getDigester7Days } from "../api/getDigester7Days"

import Digester7DayRow from "./Digester7DayRow"

import type { DigesterConfig, DigesterPod, MetricColorRange } from "../types/feedstockTypes"

export default function Digester7DayMetrics({
  groups,
  colorRanges,
}: {
  groups: DigesterPod[]
  colorRanges: MetricColorRange[][]
}) {
  const asOf = DateTime.now().setZone("America/Chicago").startOf("day").minus({ days: 1 })
  const { data, isPending } = useQuery({
    queryKey: ["digester7DayMetrics"],
    queryFn: () => getDigester7Days(asOf.toJSDate()),
  })
  let colCount = 0
  groups.forEach((g) => g.digesters.forEach(() => colCount++))
  const digesters: DigesterConfig[] = []
  groups.forEach((g) => g.digesters.forEach((d) => digesters.push(d)))

  return (
    <React.Fragment>
      <TableRow>
        <TableCell colSpan={colCount + 2} className="font-semibold text-lg px-4 pt-5">
          7-Day Averages
        </TableCell>
      </TableRow>
      <Digester7DayRow
        colorRange={colorRanges[0]}
        label={
          <>
            Hydraulic Retention Time <i>(Days)</i>
          </>
        }
        digesters={digesters}
        isPending={isPending}
        values={
          data
            ? Object.fromEntries(Object.entries(data).map(([key, value]) => [key, value.hrt]))
            : {}
        }
      />
      <Digester7DayRow
        colorRange={colorRanges[1]}
        label={
          <>
            Daily Feeding <i>(Gallons)</i>
          </>
        }
        digesters={digesters}
        isPending={isPending}
        values={
          data
            ? Object.fromEntries(Object.entries(data).map(([key, value]) => [key, value.feeding]))
            : {}
        }
      />
      <Digester7DayRow
        colorRange={colorRanges[2]}
        label={
          <>
            Gas Flow <i>(SCFM)</i>
          </>
        }
        digesters={digesters}
        isPending={isPending}
        values={
          data
            ? Object.fromEntries(Object.entries(data).map(([key, value]) => [key, value.scfm]))
            : {}
        }
      />
    </React.Fragment>
  )
}
